import { i18n, inject, pr, React, RouteComponentProps, ui } from "aaa";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { MessageScreen } from "../common/MessageScreen";
import { AliasStore } from "./AliasStore";
import profileStore from "stores/ProfileStore";
import { FeatureRoutes } from "components/app/AppRoutes";
import { history } from "stores/RouterStore";
import { GidSettingsRoutes } from "components/gidSettings/GidSettingsRoutes";
import { GidSettingsRoutes as LoginManagementGidSettingsRoutes } from "components/loginManagement/gidSettings/GidSettingsRoutes";
import { SIdentitySettingsRoutes as LoginManagementSIdentitySettingsRoutes } from "components/loginManagement/sIdentitySettings/SIdentitySettingsRoutes";
import { CardTanSettingsRoutes as LoginManagementCardTanSettingsRoutes } from "components/loginManagement/cardTanSettings/CardTanSettingsRoutes";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: AliasStore;
}

@inject("externalInterfaceStore")
export class AliasManageUsernameSuccess extends React.Component<RouteComponentProps<{}> & IProps> {
    render() {
        const hasUsername = !!this.props.store.currentUsername;

        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                title={hasUsername
                    ? ui.__("sidentitySettings.manageUsername.success.title.change")
                    : ui.__("sidentitySettings.manageUsername.success.title.add")
                }
                messageComponent={(
                    <i18n.FormattedHTMLMessage
                        id={hasUsername
                            ? "sidentitySettings.manageUsername.success.message.change"
                            : "sidentitySettings.manageUsername.success.message.add"
                        }
                    />
                )}
                buttonLabelId="sidentitySettings.manageUsername.success.close.button"
                onDismiss={async () => {
                    await profileStore.load();
                    if (history.location.pathname.startsWith(FeatureRoutes.USERMANAGEMENT)) {
                        // push back to alias feature itself
                        pushRoute(FeatureRoutes.USERMANAGEMENT);
                    } else if (history.location.pathname.startsWith(FeatureRoutes.GID_SETTINGS)) {
                        // push back to GID settings
                        pushRoute(GidSettingsRoutes.USERMANAGEMENT);
                    } else if (history.location.pathname.startsWith(FeatureRoutes.SIDENTITY_SETTINGS)) {
                        // push back to SID settings
                        pushRoute(FeatureRoutes.SIDENTITY_SETTINGS);
                    } else if (history.location.pathname.startsWith(LoginManagementGidSettingsRoutes.ROOT)) {
                        // push back to GID settings in login-management
                        pushRoute(LoginManagementGidSettingsRoutes.ROOT);
                    } else if (history.location.pathname.startsWith(LoginManagementSIdentitySettingsRoutes.ROOT)) {
                        // push back to SID settings in login-management
                        pushRoute(LoginManagementSIdentitySettingsRoutes.ROOT);
                    } else if (history.location.pathname.startsWith(LoginManagementCardTanSettingsRoutes.ROOT)) {
                        // push back to CardTan settings in login-management
                        pushRoute(LoginManagementCardTanSettingsRoutes.ROOT);
                    }
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/alias/AliasManageUsernameSuccess.tsx